import { Link } from 'react-router-dom';

export default function ArticlePreview() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-[40%]">
            <div className="rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20modern%20creative%20workspace%20with%20laptop%20open%20showing%20fashion%20spreadsheet%20colorful%20sticky%20notes%20on%20wall%20and%20curated%20wardrobe%20pieces%20hanging%20nearby%20warm%20pendant%20light%20cozy%20afternoon%20atmosphere%20personal%20productive%20studio%20aesthetic%20genuine%20lifestyle%20moment&width=600&height=750&seq=article-preview-oopbuy-v2&orientation=portrait"
                alt="OOPBuy Spreadsheet Guide"
                title="OOPBuy Spreadsheet Ratgeber"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full lg:w-[60%]">
            <p className="text-xs uppercase tracking-[0.2em] text-primary-600 mb-3 font-[family-name:var(--font-label)]">
              SEO Authority Guide
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              OOPBuy Spreadsheet
            </h2>
            <h3 className="text-xl md:text-3xl font-heading font-medium text-foreground-400 mb-8">
              Ratgeber & Neuigkeiten
            </h3>

            <blockquote className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 italic font-[family-name:var(--font-body)]">
              "Das OOPBuy Spreadsheet ist das umfassendste Tool für alle, die in Deutschland 
              hochwertige Mode, Sneaker und Accessoires entdecken möchten. In unserem ausführlichen 
              Ratgeber erfährst du alles über die Nutzung, Sicherheit und die besten Kategorien 
              des Spreadsheets - speziell für den deutschen Markt optimiert."
            </blockquote>

            <p className="text-sm text-foreground-500 mb-8 font-[family-name:var(--font-label)]">
              — OOPBuy Editorial Team
            </p>

            <Link
              to="/artikel/oopbuy-spreadsheet-ratgeber"
              className="inline-flex items-center px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold cursor-pointer whitespace-nowrap hover:bg-foreground-800 transition-all duration-300 font-[family-name:var(--font-label)]"
            >
              Zum Artikel
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}